var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 2A1.8 1.8 0 0 0 1 3.789v9.654a.45.45 0 0 0 .768.316L3.7 11.84h8.1a1.8 1.8 0 0 0 1.8-1.789V3.79A1.8 1.8 0 0 0 11.8 2h-9zm12.6 4.472v3.578c0 1.976-1.612 3.578-3.6 3.578H6.4v.895a1.8 1.8 0 0 0 1.8 1.789h8.1l1.932 1.92a.45.45 0 0 0 .768-.316V8.26a1.8 1.8 0 0 0-1.8-1.789h-1.8z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.aefd5f84229c6b93bfae5d637950f5a5.svg";
export { ForwardRef as ReactComponent };